module.exports = __webpack_public_path__ + "static/media/pro_planet_purple.8b301439.svg";